import React from 'react';
import { Home, Package2, FileText, User } from 'lucide-react';
import { useApp } from '@/context/AppContext';

const tabs = [
  { id: 'HOME', label: 'Home', Icon: Home },
  { id: 'PRODUCTS', label: 'Products', Icon: Package2 },
  { id: 'INVOICES', label: 'Invoices', Icon: FileText },
  { id: 'PROFILE', label: 'Profile', Icon: User },
];

const tabParentMap = {
  HOME: 'HOME',
  PENDING_INVOICES: 'HOME',
  UPLOAD_INVOICE: 'HOME',
  OCR_REVIEW: 'HOME',
  UPLOAD_SUCCESS: 'HOME',
  PRODUCTS: 'PRODUCTS',
  INVOICES: 'INVOICES',
  PROFILE: 'PROFILE',
};

export default function BottomNav() {
  const { currentScreen, navigate, activeTab } = useApp();
  const activeParent = tabParentMap[currentScreen] || activeTab;

  return (
    <nav
      data-testid="bottom-nav"
      className="bg-white border-t border-slate-100 flex justify-around items-center h-16 flex-shrink-0 shadow-[0_-2px_12px_rgba(0,0,0,0.06)] relative z-[9999]"
    >
      {tabs.map(({ id, label, Icon }) => {
        const isActive = activeParent === id;
        return (
          <button
            key={id}
            data-testid={`bottom-nav-${id.toLowerCase()}`}
            onClick={() => navigate(id)}
            className="flex flex-col items-center justify-center gap-0.5 w-full h-full relative tap-scale"
          >
            <Icon
              size={22}
              strokeWidth={isActive ? 2.2 : 1.7}
              color={isActive ? '#2563EB' : '#94A3B8'}
            />
            <span
              className={`text-[10px] font-semibold ${isActive ? 'text-[#2563EB]' : 'text-slate-400'}`}
            >
              {label}
            </span>
            {isActive && (
              <span className="absolute bottom-1.5 w-1 h-1 rounded-full bg-[#FF7043]" />
            )}
          </button>
        );
      })}
    </nav>
  );
}
